const LOGO_URL =
  'https://customer-assets.emergentagent.com/job_cinema-hub-693/artifacts/jhtdaos4_SMG%20ALL%20LOGO%20PNG.png';

export default function Logo({ className = '', showWordmark = true, size = 'md' }) {
  const sizes = {
    sm: 'h-8',
    md: 'h-10 md:h-12',
    lg: 'h-14 md:h-16',
    xl: 'h-24 md:h-32',
  };
  return (
    <span className={`inline-flex items-center gap-3 select-none ${className}`}>
      <img
        src={LOGO_URL}
        alt="SMG Media Group"
        className={`${sizes[size]} w-auto object-contain`}
        draggable={false}
      />
      {showWordmark && (
        <span className="hidden sm:inline text-[11px] tracking-[0.3em] text-white/70">
          MEDIA GROUP
        </span>
      )}
    </span>
  );
}
